module.exports = __webpack_public_path__ + "static/media/rekuperacja.1e0b6f89.jpg";